import React from 'react'
import { Tooltip } from 'components'

import styles from './Address.module.scss'

const Address = ({ address }) => {
  return (
    <address className={styles.wrapper}>
      <Tooltip>{address}</Tooltip>
    </address>
  )
}

export default React.memo(Address)
